import { profileToGuidelines, StyleProfile } from '../ShowStylePage/profile';

const numberOrNull = (value: unknown) =>
  value !== undefined && value !== null && value !== '' ? Number(value) : null;

interface PayloadValues {
  minColor?: string;
  maxColor?: string;
  minOg?: string;
  maxOg?: string;
  minFg?: string;
  maxFg?: string;
  minAbv?: string;
  maxAbv?: string;
  minIbu?: string;
  maxIbu?: string;
  profile: StyleProfile;
}

/**
 * Guidelines as the API stores them: the numeric parameters and the profile come from the
 * form fields, the generated (and edited) texts from the guidelines kept next to the form.
 */
export const buildGuidelinesPayload = (values: PayloadValues, guidelines: any = {}) => ({
  __type__: 'beer_guidelines',
  minColor: numberOrNull(values.minColor),
  maxColor: numberOrNull(values.maxColor),
  minOriginalExtract: numberOrNull(values.minOg),
  maxOriginalExtract: numberOrNull(values.maxOg),
  minFinalExtract: numberOrNull(values.minFg),
  maxFinalExtract: numberOrNull(values.maxFg),
  minAbv: numberOrNull(values.minAbv),
  maxAbv: numberOrNull(values.maxAbv),
  minIbu: numberOrNull(values.minIbu),
  maxIbu: numberOrNull(values.maxIbu),
  ...profileToGuidelines(values.profile),
  summary: guidelines.summary || null,
  appearanceText: guidelines.appearanceText || null,
  appearanceHighlight: guidelines.appearanceHighlight || null,
  aromaText: guidelines.aromaText || null,
  aromaHighlight: guidelines.aromaHighlight || null,
  flavorText: guidelines.flavorText || null,
  flavorHighlight: guidelines.flavorHighlight || null,
  bitternessText: guidelines.bitternessText || null,
  bitternessHighlight: guidelines.bitternessHighlight || null,
  mouthfeelText: guidelines.mouthfeelText || null,
  mouthfeelHighlight: guidelines.mouthfeelHighlight || null,
  commentsText: guidelines.commentsText || null,
  commentsHighlight: guidelines.commentsHighlight || null,
  ingredientsMalts: guidelines.ingredientsMalts || null,
  ingredientsHops: guidelines.ingredientsHops || null,
  ingredientsYeast: guidelines.ingredientsYeast || null,
  ingredientsWater: guidelines.ingredientsWater || null,
  ingredientsExtras: guidelines.ingredientsExtras || null,
  commercialExamples: guidelines.commercialExamples || [],
  sections: guidelines.sections || [],
});
